import React from 'react';
import PropTypes from 'prop-types';

import ModalWrapper from './ModalWrapper';
import Button from './Button';

import componentStyles from './NetworkErrorModal.scss';

const NetworkErrorModal = ({
  showNetworkError,
  networkErrorMessage,
  closeNetworkModal,
}) => {
  return (
    <ModalWrapper
      className={componentStyles.modalContainer}
      isOpen={showNetworkError}
      closeModal={closeNetworkModal}
    >
      {({ closeModal }) => (
        <div className={componentStyles.container}>
          <span className={`qm-icon-activity ${componentStyles.icon}`} />
          <p className={componentStyles.text}>{networkErrorMessage}</p>
          <Button
            text="Ok"
            onClick={closeModal}
            style={{
              color: 'white',
              backgroundColor: 'orange',
              width: '80%',
              cursor: 'pointer',
            }}
          />
        </div>
      )}
    </ModalWrapper>
  );
};

NetworkErrorModal.propTypes = {
  showNetworkError: PropTypes.bool.isRequired,
  networkErrorMessage: PropTypes.string.isRequired,
};

export default NetworkErrorModal;
